.avatar {
  display: inline-grid;
  place-items: center;
  flex: none;
  border-radius: var(--radius-full);
  color: var(--color-avatar-text);
  font-weight: var(--weight-semibold);
  letter-spacing: 0.01em;
  user-select: none;
}

.xs {
  width: 24px;
  height: 24px;
  font-size: 0.625rem;
}

.sm {
  width: 32px;
  height: 32px;
  font-size: var(--text-xs);
}

.md {
  width: 40px;
  height: 40px;
  font-size: var(--text-sm);
}

.lg {
  width: 56px;
  height: 56px;
  font-size: var(--text-lg);
}

.xl {
  width: 88px;
  height: 88px;
  font-size: var(--text-2xl);
}
